import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DetalleUsuarioService } from 'src/app/Services/detalle-usuario.service';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-represent-legal-form',
  templateUrl: './represent-legal-form.component.html',
  styleUrls: ['./represent-legal-form.component.css']
})
export class RepresentLegalFormComponent implements OnInit {
  formulario: FormGroup;
  params: any;
  private insertaRepr:string = environment.insrepleg;
  private insertaEmprRep:string = environment.insemprrepleg;
  private guardarArchivo:string = environment.cargaarchivo;
  nroSolicitud: number;
  doc1:any;
  doc2:any;

  constructor(private router: Router, private toastr: ToastrService, private http: HttpClient, private fb: FormBuilder, public parametroAccionService:ParametroAccionService, public detalleUsuario:DetalleUsuarioService) { 
    
    let hayParam: boolean = false;

    this.formulario = this.fb.group({
      rut: [''],
      dv: [''],
      razonSocial: [''],
      fechaIngreso: [''],
      rutRep:[''],
      dvRep:[''],
      nombreRep:[''],
      apePater:[''],
      apeMater:[''],
      correoRep:[''],
      correoRepCon:[''],
      fonoArea:[''],
      fono:[''],
      celuArea:[''],
      celu:[''],
      certf1:[''],
      certf2:['']
    });
    //console.log(this.parametroAccionService.obtenerDatos());
    this.params = this.parametroAccionService.obtenerDatos();
    if (this.params) {
      this.formulario.patchValue(this.params);
      hayParam=true;
    }
    if(hayParam){
      this.formulario.get('rut').disable();
      this.formulario.get('dv').disable(); 
      this.formulario.get('razonSocial').disable();
      this.formulario.get('fechaIngreso').disable(); 
    }
    if (this.parametroAccionService.obtenerParam()=="1") {
      /////////////////////////////////////////////////////////
    }
    this.formulario.controls['rutRep'].setValue(this.detalleUsuario.obtenerRut());
    this.formulario.controls['dvRep'].setValue(this.detalleUsuario.obtenerDv());
    this.formulario.controls['nombreRep'].setValue(this.detalleUsuario.obtenerNombre());
    this.formulario.controls['apePater'].setValue(this.detalleUsuario.obtenerApellidoP());
    this.formulario.controls['apeMater'].setValue(this.detalleUsuario.obtenerApellidoM());
    this.formulario.get('rutRep').disable(); 
    this.formulario.get('dvRep').disable();
    this.formulario.get('nombreRep').disable(); 
    this.formulario.get('apePater').disable();
    this.formulario.get('apeMater').disable(); 

    this.parametroAccionService.limpiarDatos();
  }

  ngOnInit(): void {
  }

  public fileCert1(e) {
    this.doc1 = e.target.files[0];
  };

  public fileCert2(e) {
    this.doc2 = e.target.files[0];
  };

  inserteRepr(){
    var reader = new FileReader();
    var reader2 = new FileReader();

    let thishttp = this.http;
    let thisformulario = this.formulario
    

    const insertaReprPromise = new Promise<string>((resolve, reject) => {
      //console.log("promesa 1");
      //let httpost = this.http;
      let url = `${ this.insertaRepr}`;

      this.http.post<any>(url, { 
        p_rut_repres_legal:this.formulario.get('rutRep').value,
        p_dv_repres_legal:this.formulario.get('dvRep').value,
        p_nombre_repres_legal:this.formulario.get('nombreRep').value+" "+this.formulario.get('apePater').value+" "+this.formulario.get('apeMater').value,
        p_correo_electronico:this.formulario.get('correoRep').value,
        p_user:""
      },{ observe: 'response' }).subscribe((response: HttpResponse<any>) => {
        const statusCode = response.status;
        const responseBody = response.body;
        const respuesta = responseBody.Resultado;
        //console.log("llamada insert_repr"+respuesta);
        if (statusCode === 200) {
          resolve(responseBody);
        }else if(statusCode === 202){
          resolve(responseBody);
        }else{
          console.log(respuesta);
          reject(responseBody);
        }
      }, err => {
        console.log("error capturado");
        console.log(err);
        reject(err);
        //continuar=false;
      });
    });

    const insertaReprEmprPromise = new Promise<string>((resolve, reject) => {
      //console.log("promesa 2");
      let respuesta:String;
      let url2 = `${ this.insertaEmprRep}`;
      this.http.post<any>(url2, { 
        rut_empresa:this.formulario.get('rut').value,
        rut_representante_legal:this.formulario.get('rutRep').value,
        estado_representante_empresa:1,
        email_representante:this.formulario.get('correoRep').value,
        fono_area_cdg_representante:this.formulario.get('fonoArea').value,
        fono_numero_representante:this.formulario.get('fono').value,
        celu_area_cdg_representante:this.formulario.get('celuArea').value,
        celu_numero_representante:this.formulario.get('celu').value,
        user:""
      },{ observe: 'response' }).subscribe((response: HttpResponse<any>) => {
        const statusCode = response.status;
        const responseBody = response.body;
        respuesta = responseBody.Resultado;
        this.nroSolicitud = +respuesta;
        //console.log(this.nroSolicitud);
        //console.log("llamada insert_empr_repr"+respuesta);
        if (statusCode === 200) {
          //this.toastr.success('Se ha creado la solicitud: '+respuesta);
          //console.log('Se ha creado la solicitud: '+respuesta);
          resolve(responseBody.Resultado);
        }else{
          ///console.log(respuesta);
          this.toastr.error( respuesta.toString());
          reject(responseBody);
        }
      }, err => {
        console.log("error capturado");
        console.log(err);
        reject(err);
      });
      //console.log("insertar representante");
    });
    
    const guardarArchivoPromise1 = (valorEnInsertaReprEmpr: string): Promise<string> => {
      return new Promise<string>((resolve, reject) => {
        //console.log(valorEnInsertaReprEmpr);
        reader.readAsDataURL(this.doc1);
        let nombreArchivo = this.doc1.name;
        //console.log(nombreArchivo);
        let url3 = `${this.guardarArchivo}`;
        //let thisnroSolicitud = this.nroSolicitud;
        reader.onload = function () {
          const texto = reader.result.toString().replace('data:application/pdf;base64,', '');
          //console.log(texto);
          thishttp.post(url3, {
            fileName1: nombreArchivo,
            mimeType1: "application/pdf",
            rut_representante: thisformulario.get('rutRep').value,
            rut_empresa: thisformulario.get('rut').value,
            nrosolicitud: valorEnInsertaReprEmpr,
            usuarioad: thisformulario.get('rutRep').value,
            nroarchivo: "0",
            archivo1: texto
          }, { observe: 'response' }).subscribe((response: HttpResponse<any>) => {
            const statusCode = response.status;
            const responseBody = response.body;
            //console.log(responseBody);
            //const respuesta = responseBody.Resultado;
            
            //console.log("llamada guardarArchivoPromise1"+respuesta);
            if (statusCode === 200) {
              const respuesta = responseBody.ArchivoCargado;
              //console.log(respuesta);
              //this.toastr.success('Se ha creado la solicitud: '+respuesta);
              resolve(valorEnInsertaReprEmpr);
            } else {
              const respuesta = responseBody;
              console.log(respuesta);
              reject(respuesta);
              //this.toastr.error( respuesta.toString());
            }
          }, err => {
            //console.log("error capturado");
            //console.log(err);
            reject(err);
          });
        };
        reader.abort;
      });
    }
    
    const guardarArchivoPromise2 = (valorEnInsertaReprEmpr: string): Promise<string> => {
      return new Promise<string>((resolve, reject) => {
        //console.log("promesa 4");
        reader2.readAsDataURL(this.doc2);
        let nombreArchivo = this.doc2.name;
        //console.log(this.nroSolicitud);
        let url3 = `${ this.guardarArchivo}`;
        //let thisnroSolicitud = this.nroSolicitud;
        reader2.onload =function () { 
          const texto = reader2.result.toString().replace('data:application/pdf;base64,','');
          //console.log(texto);
          thishttp.post(url3, { 
            fileName1:nombreArchivo,
            mimeType1:"application/pdf",
            rut_representante:thisformulario.get('rutRep').value,
            rut_empresa:thisformulario.get('rut').value,
            nrosolicitud:valorEnInsertaReprEmpr,
            usuarioad:thisformulario.get('rutRep').value,
            nroarchivo:"1",
            archivo1:texto
          },{ observe: 'response' }).subscribe((response: HttpResponse<any>) => {
            const statusCode = response.status;
            const responseBody = response.body;
            //console.log(responseBody);
            //const respuesta = responseBody.Resultado;
            
            //console.log("llamada guardarArchivoPromise1"+respuesta);
            if (statusCode === 200) {
              const respuesta = responseBody.ArchivoCargado;
              //console.log(respuesta);
              //this.toastr.success('Se ha creado la solicitud: '+respuesta);
              resolve(valorEnInsertaReprEmpr);
            } else {
              const respuesta = responseBody;
              console.log(respuesta);
              reject(respuesta);
              //this.toastr.error( respuesta.toString());
            }
          }, err => {
            console.log("error capturado");
            reject(err);
            console.log(err);
          });
        };
        reader2.abort;
      });
    }
    
    /*insertaReprPromise.then((mensaje) => {
      return insertaReprEmprPromise();
    }).then((valorEnInsertaReprEmpr) => {
      return guardarArchivoPromise1(valorEnInsertaReprEmpr);
    }).then(() => {
      return guardarArchivoPromise2(valorEnInsertaReprEmpr);
    }).then(() => {
      // Tareas después de completar todas las promesas
      console.log('Operación completada con éxito.');
    }).catch((error) => {
      console.error('Error:', error);
      this.toastr.error('Hubo un error en la operación');
    });*/

    if (this.formulario.get('rutRep').value<50000000) {
      insertaReprPromise
      .then(() => insertaReprEmprPromise)
      .then((mensaje) =>  {
        this.toastr.success('Se ha creado la solicitud: '+mensaje);
        this.router.navigate(['/primer']);
      })
      .catch((error) => {
        console.error("Error:", error);
        this.toastr.error(error);
      });
    }else{
      insertaReprPromise
      .then(() => insertaReprEmprPromise)
      .then((mensaje) => guardarArchivoPromise1(mensaje))
      .then((mensaje2) => guardarArchivoPromise2(mensaje2))
      .then((mensaje3) => {
        this.toastr.success('Se ha creado la solicitud: '+mensaje3);
        this.router.navigate(['/primer']);
      })
      .catch((error) => {
        console.error("Error:", error);
        this.toastr.error(error);
      });
    }


    /*insertaReprPromise.then(() =>{
      insertaReprEmprPromise.then((mensaje) =>{
        guardarArchivoPromise1(mensaje).then(() => {
          guardarArchivoPromise2().then(() => {
            this.toastr.success('Se ha creado la solicitud: '+mensaje);
          });
        });
      });
    });*/
  }
}
